<template>
  <div style="min-height: 300px">
    <div class="search-content">
      <div class="search-input">
        <el-input v-model="form.searchText" placeholder="查询姓名/地址" style="margin-bottom: 15px" clearable />
      </div>
      <div class="search-btn">
        <el-button type="primary" style="margin-bottom: 15px" @click="onSearch()">
          搜索
        </el-button>
      </div>
    </div>
    <el-button type="primary" style="margin-bottom: 15px" @click="$emit('showNew')">
      新增收货地址
    </el-button>
    <div v-for="(address,index) in list" :key="index" class="adressBox">
      <div>
        <div v-if="address.isDefault" class="defTab">
          默认
        </div>
        <div class="item">
          {{ address.receiverName }}
        </div>
        <div class="item">
          {{ address.receiverPhone }}
        </div>
        <div class="item right">
          <el-button type="text" @click="choose(address)">
            使用
          </el-button>
          <el-button v-if="!address.isDefault" type="text" @click="setDef(address)">
            设为默认地址
          </el-button>
          <el-button type="text" @click="editAddress(address)">
            编辑
          </el-button>
          <el-popover v-model="address.removeVisible" width="160" style="display: inline-block;margin: 0 10px">
            <p style="line-height: 30px">
              确认删除该地址吗?
            </p>
            <div style="text-align: right; margin: 0">
              <el-button size="mini" type="text" @click="address.removeVisible = false">
                取消
              </el-button>
              <el-button type="primary" size="mini" @click="remove(address)">
                确定
              </el-button>
            </div>
            <el-button slot="reference" type="text" style="color: #F56C6C;">
              删除
            </el-button>
          </el-popover>
        </div>
      </div>
      <div>
        <div class="item">
          {{ address.province }}
        </div>
        <div class="item">
          {{ address.city }}
        </div>
        <div class="item">
          {{ address.county }}
        </div>
        <div class="item">
          {{ address.receiptAddress }}
        </div>
      </div>
    </div>
    <div v-if="list.length" class="page">
      <el-pagination
        :current-page="page.pageIndex"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="page.pageSize"
        layout="total, prev, pager, next"
        :total="page.total"
        @current-change="handleCurrentChange"
      />
    </div>
    <div v-if="!list.length" style="text-align: center;font-size: 16px;padding-top: 50px">
      暂无数据...
    </div>
  </div>
</template>
<script type="es6">
import { settingDefaultValues, deleteReceiptAddressInfo } from '@/API';
// const filterClo = ['receiverName', 'receiptAddress', 'province', 'county', 'city'];
export default {
  data () {
    return {
    };
  },
  props: {
    list: {
      type: Array,
      default: () => {
        return [];
      }
    },
    form: {
      type: Object,
      default: () => {
        return {};
      }
    },
    page: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  components: {},
  computed: {
    // firlterList () {
    //   return this.list.filter((item) => {
    //     if (!this.searchText) {
    //       return true;
    //     } else {
    //       let b = false;
    //       filterClo.forEach((clo) => {
    //         if (!b) {
    //           b = item[clo].indexOf(this.searchText) >= 0;
    //         }
    //       });
    //       return b;
    //     }
    //   });
    // }
  },
  methods: {
    choose (val) {
      // 使用地址
      this.$emit('choose', val);
    },
    setDef (val) {
      // 设为默认
      settingDefaultValues(val.id).then((res) => {
        let json = res.data;
        if (json.status === '200') {
          this.$emit('Refresh');
        }
      }).catch((err) => {
        console.log(err);
      });
    },
    editAddress (val) {
      // 切换编辑
      this.$emit('showEdit', val);
    },
    remove (address) {
      deleteReceiptAddressInfo(address.id).then((res) => {
        let json = res.data;
        if (json.status === '200') {
          this.$emit('Refresh');
        }
      }).catch((err) => {
        console.log(err);
      });
    },
    handleCurrentChange (val) {
      this.$emit('reloadAddressIndex', val);
    },
    onSearch () {
      this.$emit('reloadAddress', this.form.searchText);
    }
  },
  mounted () {
  }
};
</script>
<style lang="scss" scoped>
  .search-content{
    display: flex;
    .search-btn{
      margin-left: 20px;
      width: 56px;
    }
    .search-input{
      flex-grow: 1;
      width: 0;
    }
  }
  .adressBox{
    margin-bottom: 15px;
    &:last-child{
      margin-bottom: 0;
    }
    .item{
      display: inline-block;
      margin-right: 5px;
      line-height: 30px;
      &.right{
        float: right;
      }
      &:last-child{
        margin-right: 0;
      }
    }
    .defTab{
      padding: 3px 10px;
      display: inline-block;
      background: #409EFF;
      font-size: 12px;
      color: #fff;
      border-radius: 4px;
      margin-right: 15px;
    }
  }
  .page{
   text-align: right;
    width: 100%;
  }
</style>
